import ReactTable from "react-table";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  FormFeedback,
  FormGroup,
  Input,
  CardTitle,
} from "reactstrap";
import { DropdownList } from "react-widgets";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import CreateNewTicketService from "../../../../../Service/DashboardServices/TroubleTicketServices/CreateNewTicketService";
import { useParams } from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWindowClose} from "@fortawesome/free-solid-svg-icons/faWindowClose";

const DropdownWithCheckbox = ({ options, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);

  const handleCheckboxChange = (value) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter((val) => val !== value));
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };

  const handleSelect = () => {
    onSelect(selectedValues);
    setOpen(false);
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <div style={{ border: '1px solid #ccc', padding: '5px', cursor: 'pointer',backgroundColor:"white"}} onClick={() => setOpen(!open)}>
        Select SKUs
      </div>
      {open && (
        <div style={{ border: '1px solid #ccc', borderTop: 'none' ,backgroundColor:"white"}}>
          {options.map((option) => (
            <label key={option} style={{ display: 'block', padding: '5px 10px' }}>
              <input
                type="checkbox"
                checked={selectedValues.includes(option)}
                onChange={() => handleCheckboxChange(option)}
              />&nbsp;
               {option}
            </label>
          ))}
          <p className="text-center p-0"><button className="btn btn-primary" onClick={handleSelect}>Apply</button></p>
        </div>
      )}
    </div>
  );
};

function CreateTicket(props) {
  
  const [checked, setChecked] = useState(false);
  const { mainTypeId, subTypeId, product, sku } = useParams();
  const [file, setFile] = useState(null);
  const [storeProductData, setStoreProductData] = useState(props.storeProducts);
  const [SKUsList, setSKUsList] = useState();
  const [asinDisplayCondition, setAsinDisplayCondition] = useState(false);
  const [query, setQuery] = useState("");
  
  const [subRequestTypes, setSubRequestTypes] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [asinArray, setAsinArray] = useState([]);
  const [formData, setFormData] = useState({
    ticketTitle: "",
    mainRequestType: props.requestTypeID ? props.requestTypeID : "",
    subRequestType: props.requestSubTypeID ? props.requestSubTypeID : "",
    product: props.asinForTicketList ? props.asinForTicketList : '',
    integerId: props.storeOverview.integerID,
    storeName: props.storeOverview.name,
    sku: "",
    ticketHistoryComment: "",
    problemAreaId : props.problemAreaId ? props.problemAreaId : '',
    problemAreaTitle:'',
    problemAreaPathwayId : props.problemAreaPathwayId ? props.problemAreaPathwayId :'',
    problemAreaPathwayTitle:''
  });
  
  const [products, setProducts] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);

  const handleSelect = (values, productId) => {
    setSelectedValues({ ...selectedValues, [productId]: values });
    console.log(selectedValues)
    const convertedArray2 = Object.keys(selectedValues).map((key) => ({ key, value: selectedValues[key] }));
    console.log('Converted array using Object.entries:', convertedArray2);
    setFormData({ ...formData, ["sku"]: selectedValues });
  };
  function handleChange(e) {
    setChecked(e.target.checked);
    const value = e.target.value
    if (e.target.checked === false) {
      const updatedArray = [...asinArray];
      updatedArray.pop(value);
      setAsinArray(updatedArray);
      setFormData({ ...formData, ["product"]: updatedArray });
      console.log(asinArray);
    } else if (e.target.checked === true) {
      const updatedArray = [...asinArray];
      updatedArray.push(value);
      setAsinArray(updatedArray);
      setFormData({ ...formData, ["product"]: updatedArray });
    }

  }

  useEffect(() => {
    if (props.subRequestTypes) {
      handleSelectSubRequestType("mainRequestType", props.problemAreaPathwayId);
    }
    if(props.problemAreaId)
    {
      props.problemAreaList.map((pa)=>{
        
        if(props.problemAreaId == pa.id)
        {
          console.log(pa.id)
          console.log(props.problemAreaId)
          console.log(pa.problemArea)
          setFormData({ ...formData, ["problemAreaTitle"]: pa.problemArea });
        }
      })
    }
    if(props.problemAreaPathwayId)  
    {
      props.problemAreaPathwayList.map((pap)=>{
        if(props.problemAreaPathwayId == pap.id)
        {
          setFormData({ ...formData, ["problemAreaPathwayTitle"]: pap.problemAreaPathway });
        }
      })
    }
  }, []);
  const handleFileChange = (e) => {
    const newFiles = [...selectedFiles];
    for (let i = 0; i < e.target.files.length; i++) {
      newFiles.push(e.target.files[i]);
    }
    setSelectedFiles(newFiles);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "mainRequestType") {
      handleSelectSubRequestType(name, value);
      setFormData({ ...formData, [name]: value });
    }
    // else if (name === "product") {
    //   addValueToArray(value);
    //   handleSelectSKUs(name, value);
    //   const updatedArray = [...asinArray];
    //   updatedArray.push(value);
    //   console.log(updatedArray);
    //   setFormData({ ...formData, [name]: updatedArray });
    // } 
    else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newFormData = new FormData();
    console.log("Form Data Submitted:", formData);
    newFormData.append("ticketTitle", formData.ticketTitle);
    newFormData.append("mainRequestType", formData.mainRequestType);
    newFormData.append("problemAreaId", formData.problemAreaId);
    newFormData.append("problemAreaPathwayId", formData.problemAreaPathwayId);
    newFormData.append("subRequestType", formData.subRequestType);
    newFormData.append("asin", formData.product);
    newFormData.append("sku", formData.sku);
    newFormData.append("integerId", formData.integerId);
    newFormData.append("storeName", formData.storeName);
    newFormData.append("ticketHistoryComment", formData.ticketHistoryComment);

    for (let i = 0; i < selectedFiles.length; i++) {
      newFormData.append("ticketAttachmentFile", selectedFiles[i]);
    }
    console.log(newFormData);
    CreateNewTicketService(props.token,newFormData).then((response) => {
      if (response) {
        props.handleCreateAndViewTicketClose(response);
      }
    });
  };
  const handleSelectSKUs = (name, productID) => {
    console.log(productID);
    props.storeProducts.map((product) => {
      if (product.asin == productID) {
        setSKUsList(product.skus);
        console.log(product.id);
        console.log(product.productTitle);
        console.log(product.skus);
      }
    });
  };
  const handleSelectSubRequestType = (name, id) => {
    const filteredSubRequestTypes = props.subRequestTypes.filter(
      (subType) => subType.problemAreaPathwayId == id
    );
    console.log("filteredSubRequestTypes:", filteredSubRequestTypes);
    filteredSubRequestTypes.map((type) =>{
      if(type.id == props.requestSubTypeID)
      {
        console.log("subRequestTypes first")
        setAsinDisplayCondition(type.asinMandatory)
      }
    })
   
    setSubRequestTypes(filteredSubRequestTypes);
    // console.log(subRequestTypes);
  };
 
  const handleRemoveFile = (file) => {
    const updatedFiles = selectedFiles.filter((f) => f !== file);
    setSelectedFiles(updatedFiles);
  };
  const filteredProductList = props.storeProducts.filter((row) => {
    const asin = row.asin.toLowerCase();
    const productTitle = row.productTitle.toLowerCase();
    
    if(row.skus != null)
    {
      const skus = row.skus.join('').toLowerCase();
      if (query !== "") {
          return (
            asin.includes(query.toLowerCase()) ||
            productTitle.includes(query.toLowerCase()) || 
            skus.includes(query.toLowerCase())
          );
      }
    }
    if (query !== "") {
      return (
        asin.includes(query.toLowerCase()) ||
        productTitle.includes(query.toLowerCase())
      );
    }
    else {
      return true; // Show all 
    }
  });

  return (
    <Container fluid className="mt-4">
      <Row className="m-0 justify-content-center">
        <Col md="12" className="mbg-3 font-size-lg p-0">
          <Card className="main-card card-of-problemarea">
            <CardBody>
              {/* <CardTitle>Create Ticket</CardTitle> */}
              <Fragment>
                {/* <Row className="divider" /> */}
                <div>
                  <form onSubmit={handleSubmit}>
                    <Row form className="justify-content-center">
                      {/* <Col md={12}>
                        <div>
                          <label htmlFor="textField1">
                            
                            <b>Subject<span style={{ color: "red" }}>*</span> : </b>
                          </label>
                          <input
                            type="text"
                            id="ticketTitle"
                            name="ticketTitle"
                            placeholder="Tilte"
                            value={formData.ticketTitle}
                            className="form-control"
                            onChange={handleInputChange}
                          />
                        </div>
                      </Col> */}
                      {/* <Col md={6}>
                        <div>
                          <label htmlFor="dropdown1">
                            {" "}
                            
                            <b>Main Request Type<span style={{ color: "red" }}>* </span> :</b>
                          </label>
                          <select
                            id="mainRequestType"
                            name="mainRequestType"
                            value={formData.mainRequestType}
                            onChange={handleInputChange}
                            className="form-control"
                          >
                            <option value="">--Select Request Type--</option>
                            {props.mainRequestTypes
                              ? props.mainRequestTypes.map((type) => (
                                  <option value={type.id}>
                                    {type.requestType}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </Col> */}
                       {/* <Col md={12}>
                        <div>
                          <label htmlFor="problemAreaTitle">
                            <b>Problem Area Type<span style={{ color: "red" }}>* </span> :</b>
                          </label>
                          <p>{formData.problemAreaTitle}</p>
                        </div>
                      </Col> */}
                      {/* <Col md={6} className="mt-2">
                        <div>
                          <label htmlFor="problemAreaPathwayTitle">
                            {" "}
                            
                            <b>Problem Area :</b>
                          </label>
                          <p>{formData.problemAreaPathwayTitle}</p>
                        </div>
                      </Col>
                      <Col md={6} className="mt-2">
                        <div>
                          <label htmlFor="subRequestType">
                            {" "}
                            
                            <b>Problem Type :</b>
                          </label> */}
                          {/* <select
                            id="subRequestType"
                            name="subRequestType"
                            value={formData.subRequestType}
                            onChange={handleInputChange}
                            className="form-control"
                          >
                            <option value="">
                              --Select Sub-Request Type--
                            </option> */}
                            {/* {subRequestTypes
                              ? subRequestTypes.map((type) => (
                                type.id == formData.subRequestType ? (
                                  <p>
                                    {type.requestSubTypes}
                                  </p>
                                ):''
                              ))
                              : ""} */}
                          {/* </select> */}
                        {/* </div>
                      </Col> */}
                      <Col md={6}>
                        <div>

                          <textarea
                            id="ticketHistoryComment"
                            name="ticketHistoryComment"
                            rows={5}
                            value={formData.ticketHistoryComment}
                            className="form-control"
                            onChange={handleInputChange}
                            placeholder="Please describe your problem" 
                          ></textarea>
                        </div>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Row>
                            <Col md={12}>
                               <label htmlFor="fileInput" className="custom-file-input-label text-center">
                                <i className="fas fa-upload"></i><br/> Choose File
                              </label>
                              <input
                                type="file"
                                id="fileInput"
                                name="ticketAttachment"
                                className="custom-file-input"
                                onChange={handleFileChange}
                              />
                              <span style={{ fontSize: "13px" }}>
                                Attached file List
                              </span>
                              <ul style={{ color: "green", fontSize: "13px" }}>
                                {selectedFiles
                                  ? selectedFiles.map((file, index) => (
                                      <li key={index}>{file.name}
                                       <button
                                className="btn"
                                
                                onClick={() => handleRemoveFile(file)}
                              >
                                <FontAwesomeIcon color="red" size="15px" icon={faWindowClose} />
                              </button>
                              </li>
                                    ))
                                  : ""}
                              </ul>
                            </Col>
                          </Row>
                        </FormGroup>
                      </Col>
                      
                      <Col md={12} className={subRequestTypes ? subRequestTypes.map((type) => (type.id == formData.subRequestType ? (type.asinDisplay ? '':' d-none'):'' )): ""}>
                        
                        <Row className='mb-2 mt-2'>
                          <Col md={6}>
                            <label htmlFor="subRequestType">
                              <b>Product(s)<span className={subRequestTypes ? subRequestTypes.map((type) => (type.id == formData.subRequestType ? (type.asinMandatory ? '':' d-none'):'' )): ""} style={{ color: "red" }}>*</span> :</b>
                            </label>
                          </Col>
                          <Col md={6} >
                            <span className={filteredProductList.length > 0 ? '':'d-none'}><input className="form-control float-right" type="text" placeholder="Search product by Title, ASIN or SKU" onChange={(e) => setQuery(e.target.value)}/></span>
                          </Col>
                        </Row>
                        <div className={filteredProductList.length > 0  ? "scrollbar ":" "}  >
                        {filteredProductList.length > 0 ? (
                          filteredProductList.map((product) => (
                            props.asinForTicketList == product.asin ? <>
                              <Row
                                className="m-0 p-0"
                              >
                                <Col md="1" className="mt-2 p-0">
                                  <div className="">
                                    <input
                                      className="mt-5 ml-4  "
                                      value={product.asin}
                                      type="checkbox"
                                      name={product.asin}
                                      onChange={handleChange}
                                      checked={props.asinForTicketList == product.asin ? true : false}
                                    />
                                  </div>
                                </Col>
                                <Col
                                  md="11"
                                  className="border row-background-color"
                                >
                                  <Row className="justify-content-center ">
                                    <Col md="2" className="p-2">
                                      <div>
                                        <img
                                          className="ml-0"
                                          width={"100%"}
                                          src={product.itemImage}
                                        />
                                      </div>
                                    </Col>
                                    <Col md="10" className="p-2">
                                      <div>
                                        <h6>
                                          <b>{product.productTitle}</b>
                                        </h6>
                                        <div className="">
                                          <Row>
                                            <Col md={5}>
                                              <span>
                                                <b>ASIN : </b> {product.asin}
                                              </span>
                                            </Col>
                                            <Col md={7}>
                                              {/* <div>
                                                <DropdownWithCheckbox options={product.skus} onSelect={(values) => handleSelect(values, product.asin)} />
                                              </div> */}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </> :props.asinForTicketList == '' ?  <>
                              <Row
                                className="m-0 p-0"
                              >
                                <Col md="1" className="mt-2 p-0">
                                  <div className="">
                                    <input
                                      className="mt-5 ml-4  "
                                      value={product.asin}
                                      type="checkbox"
                                      name={product.asin}
                                      onChange={handleChange}
                                      // checked={props.asinForTicketList == product.asin ? true : false}
                                    />
                                  </div>
                                </Col>
                                <Col
                                  md="11"
                                  className="border row-background-color"
                                >
                                  <Row className="justify-content-center ">
                                    <Col md="2" className="p-2">
                                      <div>
                                        <img
                                          className="ml-0"
                                          width={"100%"}
                                          src={product.itemImage}
                                        />
                                      </div>
                                    </Col>
                                    <Col md="10" className="p-2">
                                      <div>
                                        <h6>
                                          <b>{product.productTitle}</b>
                                        </h6>
                                        <div className="">
                                          <Row>
                                            <Col md={5}>
                                              <span>
                                                <b>ASIN : </b> {product.asin}
                                              </span>
                                            </Col>
                                            <Col md={7}>
                                              {/* <div>
                                                <DropdownWithCheckbox options={product.skus} onSelect={(values) => handleSelect(values, product.asin)} />
                                              </div> */}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </>:''                     
                          ))
                          ) : (
                            <p className="text-center"> No product available.</p>
                          )}
                        </div>
                      </Col>
                      
                    </Row>
                   {asinDisplayCondition ?
                    (<p className=" mt-3 text-center">
                    <Button
                      className="btn_class"
                      disabled={
                        !(formData.ticketHistoryComment && (formData.product.length > 0 && asinDisplayCondition)) 
                      }
                    >
                      Submit
                    </Button>
                  </p>):
                  (<p className=" mt-3 text-center">
                  <Button
                    className="btn_class"
                    disabled={
                     ! formData.ticketHistoryComment
                    }
                  >
                    Submit
                  </Button>
                </p>)
                   } 
                  </form>
                </div>
              </Fragment>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
  };
};

export default connect(mapStateToProps)(CreateTicket);
